import { useNavigate, useParams, useLocation } from 'react-router-dom';

const WrapComps = (props) => {
  const navigate = useNavigate();
  const params = useParams();
  const location = useLocation();
  // eslint-disable-next-line
  const Element = props.el;
  return (
    <Element
      params={params}
      navigate={navigate}
      location={location}
        // eslint-disable-next-line react/jsx-props-no-spreading
      {...props}
    />
  );
};

export default WrapComps;
